// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "7bedb66ba18126e329714e227369409132f1b6e1/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};